var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start"},[_c('h1',[_vm._v("Informacje od nauczyciela:")]),(_vm.group.description !== '')?_c('p',[_vm._v(_vm._s(_vm.group.description))]):_c('p',[_vm._v("Brak informacji od nauczyciela.")])])}
var staticRenderFns = []

export { render, staticRenderFns }